export const state = () => ({
  bankIdStatus: {},
  deeplink: {},
  userStatus: {},
})

export const mutations = {
  setBankIdStatus(state, data) {
    state.bankIdStatus = data
  },

  setDeeplink(state, data) {
    state.deeplink = data
  },

  setUserStatus(state, data) {
    state.userStatus = data
  },
}

export const actions = {
  async bankIdStatus({ commit }) {
    try {
      const res = await this.$api.bankid.getBankIdStatus()
      commit('setBankIdStatus', res.data)
    }
    catch (err) {
      console.log(err)
    }
  },

  async deeplink({ commit }) {
    try {
      const res = await this.$api.bankid.getDeeplinkBankid()
      commit('setDeeplink', res.data)
    }
    catch (err) {
      console.log(err)
    }
  },

  async userStatus({ commit }) {
    try {
      const res = await this.$api.bankid.getUserStatusBankid()
      commit('setUserStatus', res.data)
    }
    catch (err) {
      console.log(err)
    }
  },
}

export const getters = {
  getBankIdStatus: state => state.bankIdStatus,
  getDeeplink: state => state.deeplink,
  getUserStatus: state => state.userStatus,
}
